import { render } from "./NextTable.vue?vue&type=template&id=1593d05e&ts=true"
import script from "./NextTable.vue?vue&type=script&lang=ts"
export * from "./NextTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__